import React, { useState, useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  Route,
  Routes,
  BrowserRouter,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useNavigate } from "react-router-dom";

import "./App.css";
import SideBar from "./components/SideBar/SideBar";
import SaleReport from "./components/SaleReport/SaleReport";
import PricingSavedSearch from "./components/PricingSavedSearch/PricingSavedSearch";
import InventoryReport from "./components/InventoryReport/InventoryReport";
import AgingReport from "./components/AgingReport/AgingReport";
import Subscription from "./components/Subscription/Subscription";
import Cookies from "js-cookie";
import Login from "./components/ui/authentication/loginPCP";

import "bootstrap/dist/css/bootstrap.min.css";
import Header_2 from "./components/Header/Header_2";

import PageContainer from "./components/PageContainer/PageContainer";
import RapnetModal from "./components/RapNetModal/RapnetModal";
import amplitude from "./utils/ampli";
import PriceItemDetails from "./pages/priceItemDetails";
import { useDispatch, useSelector } from "react-redux";
import { setUserDetailsState, clearUserDetailsState } from "./redux/slices/authSlice";
import PriceCoPilot from "./pages/priceCoPilot";
import Sidebar from "./components/sidebar";
import { cn } from "./utils/utils";
import { motion } from "framer-motion";
import { useGetConfigQuery } from "./redux/slices/apiSlice";
import { pricing, setConfig } from "./redux/slices/pricingSlice";
import { commonComponent, setAlertText, setSeverity, setToast } from "./redux/slices/commonComponentSlice";
import { Snackbar, Alert } from "@mui/material";
import BIAnalysis from "./components/BIAnalysis/BIAnalysis";
import PCPDashboard from "./components/PCPDashboard/PCPDashboard";
import HigherLevelAnalysis from "./components/HigherLevelAnalysis/HigherLevelAnalysis";
import MarketIntelligence from "./components/marketIntelligence/MarketIntelligenc";
import GlobalProgressBar from "./components/GlobalProgressBar";

const session_api = "/my_profile";
const MY_ROUTES = {
  "/inventory_report": "Inventory Report",
  "/sale_report": "Sales Report",
  "/aging_report": "Aging Report",
  "/price_co-pilot": "Pricing Co-Pilot",
  "/saved_search": "Saved Searches",
};
const route_icons = {
  "/inventory_report": <i className="bi bi-clipboard2-data"></i>,
  "/sale_report": <i className="bi bi-graph-up-arrow"></i>,
  "/aging_report": <i className="bi bi-clock-history"></i>,
  "/price_co-pilot": <i className="bi bi-clipboard2-data"></i>,
  "/saved_search": <i className="bi bi-clipboard2-data"></i>,
};

const App = () => {
  const [userDetails, setUserDetails] = useState({});
  const [tokenLoaded, setTokenLoaded] = useState(false);
  const [analyticsSusbscribed, setAnalyticsSusbscribed] = useState(false);
  const [analyticsFreeLimitUseCount, setAnalyticsFreeLimitUseCount] =
    useState(5);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const goToLoginWithRedirect = () => {
  // avoid nesting redirect loops
  if (window.location.pathname === '/login') {
    navigate('/login'); 
    return;
  }
  const target = window.location.pathname + window.location.search;
  const encoded = encodeURIComponent(target);
  // store also in sessionStorage (fallback if query stripped)
  sessionStorage.setItem('post_login_redirect', target);
  navigate(`/login?redirect=${encoded}`, { replace: true });
};
  useEffect(() => {
    const script = document.createElement("script");
    // const bootstrap1 = document.createElement("script")

    // const css = document.createElement("link")
    // css.rel = "stylesheet"
    // css.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css"
    // css.integrity = "sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65"
    // css.crossOrigin = "anonymous"
    // css.async = true
    // document.body.appendChild(css)
    // bootstrap1.src = "https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js"
    // bootstrap1.integrity = "sha384-QJHtvGhmr9XOIpI6YVutG+2QOK9T+ZnN4kzFN1RtK3zEFEIsxhlmWl5/YESvpZ13"
    // bootstrap1.crossOrigin = "anonymous"
    // bootstrap1.async = true
    // const bootstrap2 = document.createElement("script")
    // bootstrap2.src = "https://cdn.jsdelivr.net/npm/@popperjs/core@2.10.2/dist/umd/popper.min.js"
    // bootstrap2.integrity = "sha384-7+zCNj/IqJ95wo16oMtfsKbZ9ccEh31eOz1HGyDuCQ6wgnyJNSYdrPa03rtR1zdB"
    // bootstrap2.crossOrigin = "anonymous"
    // bootstrap2.async = true
    // document.body.appendChild(bootstrap2)

    // document.body.appendChild(bootstrap1)

    script.src = "assets/js/main.js";
    script.async = true;
    document.body.appendChild(script);

    const queryParams = new URLSearchParams(window.location.search);
    var accessToken = queryParams.get("access_token");
    // console.log("Component Did Mount Called");
    if (accessToken) {
      // document.cookie = "access_token=" + accessToken;
      // queryParams.delete("access_token");
      // window.location.search = queryParams;
      Cookies.set("access_token", accessToken);
      queryParams.delete("access_token");
      window.location.search = queryParams;
    } else {
      accessToken = Cookies.get("access_token");

      if (!accessToken) {
        // console.warn("Session Expired:  No access token");
        // console.log(
        //   "Session Expired, Please login again 1, access token is:",
        //   accessToken
        // );
      //   if (!tokenLoaded) {
      //   alert("Session Expired, Please login again");
      //   navigate("/login");
      //   return;
      // }
        // alert("Session Expired, Please login again");
        // Instead of redirecting to 'https://app.liquid.diamonds/#/sessions/new', we are redirecting it to 'https://app.liquid.diamonds/'. since if user is signed out it will automatically redirect to 'https://app.liquid.diamonds/#/sessions/new'
        // window.location = process.env.REACT_APP_AUTH_URL
        // window.location = process.env.REACT_APP_API_URL;
        // navigate("/login");
        // return 0;
      }
    }
   if (!tokenLoaded){
    // console.log("Fetching url", process.env.REACT_APP_API_URL + session_api, "with access token", accessToken)
    fetch(process.env.REACT_APP_API_URL + session_api, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + accessToken,
        "ngrok-skip-browser-warning": true,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.errors) {
          // alert("Session Expired, Please login again");
          // window.location = process.env.REACT_APP_API_URL;
          // window.location.href = "/login"
          goToLoginWithRedirect();
          return;
        } else {
          // this.setState({ userDetails: response.data, tokenLoaded: true, analyticsSusbscribed: response.analytics_subscribed, AnalyticsFreeLimitUseCount: response.analytics_free_limit_use_count })
          dispatch(
            setUserDetailsState({
              details: response.data,
              token: accessToken,
            })
          ); // making a redux call and storing the data.
          setTokenLoaded(true);
          setUserDetails(response.data);
          
          // console.log(response.data);
          amplitude.setUserId(response.data.email);
          if(response?.data?.email && (response?.data?.email.includes("@liquid.diamonds") || response?.data?.email.includes("@dtspoint.com"))){
            amplitude.setOptOut(true);
          }
           Sentry.setUser({
            email: response.data.email,
            
          });
          // window.clarity("set", "email", response.data.email);
          // window.clarity("set", "userId", response.data.email);
          setAnalyticsSusbscribed(response.analytics_subscribed);
          setAnalyticsFreeLimitUseCount(
            response.analytics_free_limit_use_count
          );
          // setAnalyticsSusbscribed(false);

          // setAnalyticsFreeLimitUseCount(0);
          
          
        }
      })
      .catch((error) => {
        // let user_url = process.env.REACT_APP_API_URL + session_api;
        // console.log(
        //   "Caught in catch function while fetching the api",
        //   user_url,
        //   "with access token",
        //   accessToken
        // );
        // console.log("Error: " + error);
        // alert('Session Expired, Please login again 4')
        // window.location = process.env.REACT_APP_AUTH_URL
        console.error("Fetch error:", error);
        // alert("Session Expired, Please login again");
        goToLoginWithRedirect();
      });

}
  }, [tokenLoaded, navigate]);

  let search = window.location.search;
  let url = window.location.pathname;
  const urlParams = new URLSearchParams(search);
  let sellerIds = urlParams.get("sellerIds");
  let startDate = urlParams.get("startDate");
  let endDate = urlParams.get("endDate");
  let searchParams = sellerIds ? "?sellerIds=" + sellerIds : "";
  if (url === "/sale_report") {
    if (startDate) {
      if (searchParams) searchParams += "&startDate=" + startDate;
      else searchParams = "?startDate=" + startDate;
    }
    if (endDate) {
      if (searchParams) searchParams += "&endDate=" + endDate;
      else searchParams = "?endDate=" + endDate;
    }
  }

  let isCsr = userDetails.roles && userDetails.roles.includes("csr");
  let isAnalyticsFreeLimitRemaining =
    analyticsFreeLimitUseCount <= 5 ? true : false;

  // for production
  let showSubscribePageOnly = !(
    isCsr ||
    analyticsSusbscribed ||
    isAnalyticsFreeLimitRemaining
  );

  // let showSubscribePageOnly = !(
  //   analyticsSusbscribed || isAnalyticsFreeLimitRemaining
  // );

  // console.log({
  //   isCsr,
  //   analyticsSusbscribed,
  //   isAnalyticsFreeLimitRemaining,
  //   showSubscribePageOnly,
  //   analyticsFreeLimitUseCount,
  // });
  // staging/local
  // let showSubscribePageOnly = !(analyticsSusbscribed || isAnalyticsFreeLimitRemaining)
  if (url === "/subscribe") {
    showSubscribePageOnly = true;
  }

  const [openModal, setOpenModal] = useState();
  const setRapnetCredsTrue = () => {
    setUserDetails((prev) => ({
      ...prev,
      is_rapnet_credentials: true,
    }));
  };

  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const location = useLocation();
  const toggleSidebar = () => {
    setSidebarVisible((prev) => !prev);
  };

  const mainVariants = {
    visible: {
      marginLeft: "250px",
      width: "calc(100% - 250px)",
      transition: {
        duration: 0.2,
        ease: "easeIn",
      },
    },
    hidden: {
      marginLeft: "50px",
      width: "calc(100% - 50px)",
      transition: {
        duration: 0.2,
        ease: "easeOut",
      },
    },
  };

  

  const {
    data: configData,
    isLoading: configLoading,
    isSuccess: configSuccess,
    isError: configIsError,
    error: configError,
  } = useGetConfigQuery(
    {
      accId: userDetails.account_id,
    },
    {
      skip: !userDetails.account_id ? true : false,
    }
  );

  useEffect(() => {
    if (configData) {
      dispatch(setConfig(configData?.data));
    }
  }, [configData]);

  const handleClick = () => {
    dispatch(setToast(true));
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    dispatch(setToast(false));
  };
  const cComponent =  useSelector(commonComponent);
  const severity = cComponent?.severity;
  const alertText = cComponent?.alertText;
  const handleToast = cComponent?.openToast;
  const shouldRedirectToStockPerformance =
    tokenLoaded && (String(userDetails?.account_id) === "552" || String(userDetails?.account_id) === "1130") ;
  const isPricingCoPilotOnly =
    tokenLoaded && ( String(userDetails?.account_id) === "93");
  return (
    <div className="overflow-hidden">
      <GlobalProgressBar />
      {/* <Header showSubscribePageOnly={showSubscribePageOnly} userDetails={userDetails} analyticsSusbscribed={analyticsSusbscribed} tokenLoaded={tokenLoaded} /> */}
      <Snackbar
        open={handleToast}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{vertical: 'bottom', horizontal:'right'}}
      >
        <Alert
          onClose={handleClose}
          severity={severity}
          variant="filled"
          sx={{ width: '100%'}}
        >
          {alertText}
        </Alert>
      </Snackbar>
      <RapnetModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        isSet={userDetails["is_rapnet_credentials"]}
        toggleRapnet={setRapnetCredsTrue}
      />

      {tokenLoaded && userDetails?.email && location.pathname !== "/login" && (
        <Header_2
          showSubscribePageOnly={showSubscribePageOnly}
          userDetails={userDetails}
          analyticsSusbscribed={analyticsSusbscribed}
          tokenLoaded={tokenLoaded}
          setOpenModal={setOpenModal}
          toggleSidebar={toggleSidebar}
          isCsr={isCsr}
          setTokenLoaded={setTokenLoaded}
        />
      )}

      {location.pathname !== '/login' && !showSubscribePageOnly && tokenLoaded && userDetails?.account_id && (
        <Sidebar shouldRedirectToStockPerformance={shouldRedirectToStockPerformance} isPricingCoPilotOnly={isPricingCoPilotOnly} isVisible={isSidebarVisible} toggleSidebar={toggleSidebar} />
      )}

      {location.pathname !== "/login" && tokenLoaded ? (
        <motion.main
          id={"main"}
          className={cn(
            "main h-[calc(100vh-50px)] !mt-[50px] overflow-auto w-full",
            isSidebarVisible
              ? "ml-[250px] w-[calc(100%-250px)]"
              : "ml-[50px] w-[calc(100%-50px)]",
          )}
          initial="hidden"
          animate={isSidebarVisible ? "visible" : "hidden"}
          variants={mainVariants}
        >
          <Routes>
            {showSubscribePageOnly ? (
              <>
                <Route
                  path="/subscribe"
                  element={[<Subscription key="subscribe" />]}
                />
                <Route path="/*" element={<Navigate to="/subscribe" />} />
              </>
            ) : isPricingCoPilotOnly ? (
              <>
                <Route
                  path="/"
                  element={<Navigate to="/dashboard" replace />}
                />
                <Route
                  path="/dashboard"
                  element={[
                    <PCPDashboard
                      isCsr={isCsr}
                      key="dashboard"
                      accountDetails={userDetails}
                    />,
                  ]}
                />
                <Route
                  path="/saved_search"
                  element={[
                    <PricingSavedSearch isCsr={isCsr} key="saved_searches" />,
                  ]}
                />
                <Route
                  path="/price_co-pilot"
                  element={[
                    <PriceCoPilot isCsr={isCsr} accountDetails={userDetails} />,
                  ]}
                  key="price_co-pilot"
                />
                <Route
                  path="/price_co-pilot/:itemId"
                  element={<PriceItemDetails id={userDetails.account_id} />}
                  key="price_details"
                />
                <Route path="/*" element={<Navigate to="/dashboard" replace />} />
              </>
            ) : (
              <>
                <Route
                  path="/"
                  element={
                    shouldRedirectToStockPerformance ? (
                      <Navigate to="/stock_performance" replace />
                    ) : (
                      <Navigate to="/dashboard" replace />
                    )
                  }
                />
                <Route
                  path="/saved_search"
                  element={[
                    <PricingSavedSearch isCsr={isCsr} key="saved_searches" />,
                  ]}
                />

                <Route
                  path="/sale_report"
                  element={[
                    <SaleReport
                      isCsr={isCsr}
                      key="sale_reports"
                      accountDetails={userDetails}
                    />,
                  ]}
                />

                <Route
                  path="/inventory_report"
                  element={[
                    <InventoryReport
                      isCsr={isCsr}
                      key="inventory_reports"
                      accountDetails={userDetails}
                    />,
                  ]}
                />
                {/* <Route
                      path="/login"
                      element={<Login />}
                      key="price_co-pilot_login"
                    /> */}
                <Route
                  path="/stock_performance"
                  element={[
                    <BIAnalysis
                      isCsr={isCsr}
                      key="bi_analysis"
                      accountDetails={userDetails}
                    />,
                  ]}
                />
                <Route
                  path="/market_intelligence"
                  element={[
                    <HigherLevelAnalysis
                      isCsr={isCsr}
                      key="market_intelligence"
                      accountDetails={userDetails}
                    />,
                  ]}
                />
                <Route
                  path="/market_performance"
                  element={[
                    <MarketIntelligence
                      isCsr={isCsr}
                      key="market_intelligence1"
                      accountDetails={userDetails}
                    />,
                  ]}
                />
                <Route
                  path="/dashboard"
                  element={[
                    <PCPDashboard
                      isCsr={isCsr}
                      key="dashboard"
                      accountDetails={userDetails}
                    />,
                  ]}
                />

                <Route
                  path="/aging_report"
                  element={[<AgingReport isCsr={isCsr} />]}
                  key="aging_reports"
                />
                <Route
                  path="/price_co-pilot"
                  element={[
                    <PriceCoPilot isCsr={isCsr} accountDetails={userDetails} />,
                  ]}
                  key="price_co-pilot"
                />

                {/* <Route
                    path="/price_co-pilot/:page"
                    element={[
                      <PriceCoPilot isCsr={isCsr} accountDetails={userDetails} />,
                    ]}
                    key="price_co-pilot"
                  /> */}
                <Route
                  path="/price_co-pilot/:itemId"
                  element={<PriceItemDetails id={userDetails.account_id} />}
                  key="price_details"
                />
              </>
            )}
          </Routes>
        </motion.main>
      ) : (
        <main id="main" className="">
          {/* login route */}
          <Routes>
            <Route
              path="/login"
              element={<Login />}
              key="price_co-pilot_login"
            />
            {/* <Route path="*" element={<Navigate to="/login" />} />     */}
          </Routes>
        </main>
      )}
    </div>
  );
};

export default App;

/*
shape
size
color
clarity
flour
nobgm
cert
table
deplth
measur
girdle
ratio


location


Rapnet Creds
Price Copilot
Same styles for bottom table
filter header
*/
